import Icon from 'veui/components/Icon'

Icon.register({
  trash: {
    paths: [
      {
        d: 'M42 15a2 2 0 012 2v22.5a6.5 6.5 0 01-6.5 6.5h-27A6.5 6.5 0 014 39.5V17a2 2 0 114 0v22.5a2.5 2.5 0 002.5 2.5h27a2.5 2.5 0 002.5-2.5V17c0-1.1.9-2 2-2zm-24 2.52a2 2 0 012 2V36a2 2 0 11-4 0V19.52c0-1.1.9-2 2-2zm12 0a2 2 0 012 2V36a2 2 0 11-4 0V19.52c0-1.1.9-2 2-2zM28.98 2a4.17 4.17 0 014.14 3.23l.02.12.24 1.65H44a2 2 0 110 4H31.65a2 2 0 01-1.98-1.71l-.47-3.25c-.01 0-.09-.04-.22-.04H17.91c-.14 0-.2.04-.23.04l-.47 3.25A2 2 0 0115.23 11H4a2 2 0 110-4h9.5l.24-1.65.02-.12A4.17 4.17 0 0117.91 2z'
      }
    ],
    width: '48',
    height: '48'
  }
})
